export function toDateOnlyString(d: Date): string {
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

export function isDateOnlyString(s?: string): s is string {
  return typeof s === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(s);
}

export function formatDateForDisplayFromString(dateStr?: string): string {
  if (!dateStr) return '';
  if (isDateOnlyString(dateStr)) {
    const [y, m, d] = dateStr.split('-');
    return `${d}/${m}/${y}`;
  }
  try {
    return new Date(dateStr).toLocaleDateString('pt-BR');
  } catch {
    return dateStr;
  }
}

export function parseDateOnlyStringToDate(s: string): Date {
  const [y, m, d] = s.split('-').map(Number);
  return new Date(y, m - 1, d);
}

export interface MonthlyPeriodBounds {
  startDateOnly: string;
  endDateOnly: string;
  startIso: string;
  nextMonthStartIso: string;
}

export function getMonthlyPeriodBounds(month: string): MonthlyPeriodBounds {
  const match = /^(\d{4})-(\d{2})$/.exec(month);
  if (!match) {
    throw new Error(`Mês inválido: ${month}. Use formato YYYY-MM.`);
  }

  const year = Number(match[1]);
  const monthNumber = Number(match[2]);
  if (!Number.isFinite(year) || !Number.isFinite(monthNumber) || monthNumber < 1 || monthNumber > 12) {
    throw new Error(`Mês inválido: ${month}. Use formato YYYY-MM.`);
  }

  const startLocal = new Date(year, monthNumber - 1, 1, 0, 0, 0, 0);
  const endLocal = new Date(year, monthNumber, 0, 23, 59, 59, 999);
  const nextMonthStartLocal = new Date(year, monthNumber, 1, 0, 0, 0, 0);

  return {
    startDateOnly: toDateOnlyString(startLocal),
    endDateOnly: toDateOnlyString(endLocal),
    startIso: startLocal.toISOString(),
    nextMonthStartIso: nextMonthStartLocal.toISOString(),
  };
}
